import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const Skeleton = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="50%" disableSpaceBelow />
      <SkeletonBlock $width="40%" disableSpaceBelow />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 2rem;
  width: 100%;
`;
